import {
  MORAL_RESULT_LIST_SEARCH, MORAL_RESULT_LIST_SEARCH_FAILURE, MORAL_RESULT_LIST_SEARCH_SUCCESS, MORAL_RESULT_DATA_DOWNLOAD, MORAL_RESULT_DATA_DOWNLOAD_FAILURE, MORAL_RESULT_DATA_DOWNLOAD_SUCCESS
} from './mutation-types'

export default {
  state: {
    morals: [],
    moralResultListNextPage: null,
    moralResultListCurrentPage: null,
    moralResultData: []
  },
  getters: {
    moralResultList: state => {
      return state.morals
    },
    moralResultListNextPage: state => {
      return state.moralResultListNextPage
    },
    moralResultListCurrentPage: state => {
      return state.moralResultListCurrentPage
    },
    moralResultData: state => {
      return state.moralResultData
    }
  },
  actions: {
    [MORAL_RESULT_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/master/morals/result/list'
      var callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MORAL_RESULT_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(MORAL_RESULT_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [MORAL_RESULT_DATA_DOWNLOAD] ({dispatch, state, commit}, params = null) {
      console.log('MORAL_RESULT_DATA_DOWNLOAD')
      var callback = () => {}
      var data = {}
      if (params) {
        data = params.data
        callback = params.callback
      }
      dispatch('apiGet', { url: '/master/morals/result/data_download', data: data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MORAL_RESULT_DATA_DOWNLOAD_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(MORAL_RESULT_DATA_DOWNLOAD_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [MORAL_RESULT_LIST_SEARCH_FAILURE] (state, params) {
      console.log('MORAL_RESULT_LIST_SEARCH_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [MORAL_RESULT_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('MORAL_RESULT_LIST_SEARCH_SUCCESS')
      var data = params.data
      if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
        state.morals = state.morals.concat(data.data)
        state.moralResultListCurrentPage = data.meta['current-page']
      } else {
        state.morals = data.data
        state.moralResultListCurrentPage = 1
      }
      if (data.links && data.links['next']) {
        state.moralResultListNextPage = data.links['next']
      } else {
        state.moralResultListNextPage = null
      }
      if (params.callback) {
        params.callback()
      }
    },
    [MORAL_RESULT_DATA_DOWNLOAD_FAILURE] (state, data) {
      console.log('MORAL_RESULT_DATA_DOWNLOAD_FAILURE')
    },
    [MORAL_RESULT_DATA_DOWNLOAD_SUCCESS] (state, data) {
      console.log('MORAL_RESULT_DATA_DOWNLOAD_SUCCESS')
      state.moralResultData = data.data.data
      data.callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/moral-result-list.js